namespace RioERP.Enquiry {
    export interface PendingOrderEnquiryForm {
        OrderIds: Serenity.StringEditor;
        EStatus: Serenity.EnumEditor;
        FollowupDate: Serenity.DateEditor;
        HandledBy: Serenity.LookupEditor;
    }

    export class PendingOrderEnquiryForm extends Serenity.PrefixedContext {
        static formKey = 'RioERP.PendingOrderEnquiry';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PendingOrderEnquiryForm.init)  {
                PendingOrderEnquiryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.DateEditor;
                var w3 = s.LookupEditor;

                Q.initFormType(PendingOrderEnquiryForm, [
                    'OrderIds', w0,
                    'EStatus', w1,
                    'FollowupDate', w2,
                    'HandledBy', w3
                ]);
            }
        }
    }
}
